module.exports = __webpack_public_path__ + "img/GT_gue.aefd30bb.png";